import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import '@/plugins/vue-filters'
import '@/plugins/vue-cookies'
import ApiService from '@/services/ApiService'
import ErrorHandlingService from '@/services/ErrorHandlingService'
import '@/registerServiceWorker'

Vue.config.productionTip = false

ErrorHandlingService.init(store)
ApiService.init(store)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
